import SectionHeading from "@/components/base/SectionHeading";
import Reveal from "@/components/base/Reveal";
import { useSiteContent } from "@/context/SiteContentContext";

export default function Services() {
  const { services, sections } = useSiteContent();
  const content = sections.servicios || {};

  return (
    <section id="servicios" className="relative py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8 lg:px-12">
        <SectionHeading
          eyebrow="Qué hacemos"
          title={String(content.title || "Construimos soluciones digitales, no solo páginas web.")}
          subtitle={String(
            content.subtitle ||
              "Desde una página corporativa hasta plataformas completas de gestión, creamos soluciones adaptadas a las necesidades reales de cada negocio."
          )}
        />

        <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {services.map((service, i) => (
            <Reveal key={service.id} delay={(i % 3) * 80}>
              <div className="group h-full rounded-2xl border border-background-200 bg-background-50 p-6 md:p-7 transition-all duration-300 hover:-translate-y-1.5 hover:border-primary-200 hover:shadow-[0_16px_40px_rgba(30,60,120,0.08)] cursor-default">
                <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-xl bg-primary-50 text-primary-600 mb-5 transition-all duration-300 group-hover:bg-primary-500 group-hover:text-background-50">
                  <i className={`${service.icono || "ri-global-line"} text-2xl`} />
                </div>
                <h3 className="text-lg md:text-xl font-semibold text-foreground-950 mb-2.5">
                  {service.nombre}
                </h3>
                <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                  {service.descripcion}
                </p>
              </div>
            </Reveal>
          ))}
        </div>

        {services.length === 0 && (
          <p className="mt-12 text-center text-foreground-500">
            Pronto publicaremos nuestros servicios.
          </p>
        )}
      </div>
    </section>
  );
}